import { render } from "./App.vue?vue&type=template&id=5ae7aa1d"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5ae7aa1d&lang=css"
script.render = render

export default script